// extracted by mini-css-extract-plugin
export default {"imageSection":"ImageSection_imageSection__+p2Bp","wordRank":"ImageSection_wordRank__TMOUv","moreOptions":"ImageSection_moreOptions__nvq32","close":"ImageSection_close__0cFpM"};